import { Button } from '@fattureincloud/fic-design-system'
import { faExternalLinkAlt, faPrint } from '@fortawesome/pro-light-svg-icons'
import React, { FC } from 'react'

import { printArticlePdf } from '../../common/utils'
import { Actions } from './article.components'

interface Props {
  viewportWidth: number
  subArticle: boolean
  isExternal: boolean
  editedArticlePermalink: string
  realm: string
  articleId: string | number
}

const ReadonlyArticleActions: FC<Props> = (props: Props) => {
  const url = props.realm == 'fic' ? 'https://help.fattureincloud.it' : 'https://help.dipendentincloud.it'
  return (
    <Actions>
      {props.viewportWidth > 768 && (
        <Button type={'text'} iconLeft={{ icon: faPrint }}
                onClick={() => printArticlePdf(props.articleId)}
        />
      )}
      {!props.subArticle && !props.isExternal && (
        <Button
          type={'text'}
          iconLeft={{ icon: faExternalLinkAlt }}
          href={url + '/help/articolo/' + props.editedArticlePermalink}
          target={'_blank'}
        />
      )}
    </Actions>
  )
}

export default ReadonlyArticleActions
